"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidParent = getValidParent;
function getValidParent(container, cssClass) {
  if (!cssClass) {
    return document;
  }
  const parent = container.parentElement;
  if (parent) {
    if (Array.from(parent.classList).find(clss => clss.includes(cssClass))) {
      return parent;
    } else {
      return getValidParent(parent, cssClass);
    }
  }
  return document;
}